import { produce } from 'immer';

import { ShowErrorsCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/showErrorsCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function showErrorsCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: ShowErrorsCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId, errors } = action;

        draft[editorId].errors = errors;
        draft[editorId].isOpen = true;
    });
}
